import React, {useEffect, useState} from 'react'
// Actions
import { Base_API } from '../../_actions/matcher';
// Styles
import './nhsvs.style.css'
// Images
import CouponImage from '../../assets/images/rewards/reward-detail.png'
// Components
import Choose_Order from '../../components/chooseOrder/index'
import PackageDetail from '../../components/packageDetail/index'
import Overlay from '../../components/Overlay'
// Line Liff
import liff from '@line/liff'
// APIs
import { NhealthAction } from '../../_actions/action.api'
import { useParams } from 'react-router-dom'
import { DecryptedOBJ, EncryptedOBJ, EncryptedText, DecryptedText } from '../../utils/Encryption';
import lineConfig from '../../_actions/authLine/lineConfig';
import useLineLogin from '../../_actions/authLine/lineLogin';

function ProductsOnline(props) {
    const { ref } = useParams(); 

    const [packSelected, setPackSelected] = useState([]);
    const [packOrder, setPackOrder] = useState([]);
    const [openDetail, setOpenDetail] = useState(false);
    const [quantitySelected, setQuantitySelected] = useState(0);
    const [campaignData, setCampaignData] = useState(null);
    const [packages, setPackages] = useState(null);
    const [loading, setLoading] = useState(true);
    const [pageDetail, setPageDetail] = useState({
        totalAmount: 0,
        totalPrice: '',
        promotionText: ''
    });

    // check
    useEffect(() => {
        if(window.localStorage.getItem('package_selected') !== null)
        {
            window.localStorage.removeItem('package_selected');
            window.location.reload();
        }
    })
    useEffect(() => {
        //! Check Status Campaign (For Prod)
        // checkStatusCampaign();
        //! For Prod
        dataInit();
    },[])

    const dataInit = async() => {
        let currentURL = EncryptedText(String(location.href).split('?')[0]);
        localStorage.setItem(process.env.REACT_APP_ENC_NAME_SIGNED_CALLBACK_URL, currentURL)

        await refInit();
        removeOpenExternalPath();
        await useLineLogin(lineConfig.nh_services);
        let mem_id = await checkUserInit();
        await packagesInit(); 
        let campaignData = await campaignInit();
        await calCartInit(campaignData,mem_id);
        handleLoader('inactive');  
    }

    const removeOpenExternalPath = () => {
        let pathname = location.href;
        if(pathname.indexOf('?openExternalBrowser=1') >= 0)
        {
            let newpath = pathname.replace('?openExternalBrowser=1', '');
            location.href = newpath;
        }
    }

    const handleLoader = status => {
        if(status === 'inactive')
        {
            setLoading(false);
        }else
        {
            setLoading(true);
        }
    }

    const refInit = () => {
        return new Promise(async resolve => {
            if(ref !== 'ref')
            {
                localStorage.setItem('refredirect', EncryptedText(ref));
            }
            resolve();
        })
    }

    const calCartInit = (campaignData, membercode) => {
        return new Promise(async resolve => {
            NhealthAction.CalCart(campaignData.id, 0, membercode)
            .then(res => {
                // console.log('cal cart data: ', res);
                setPageDetail({
                    ...pageDetail,
                    totalAmount: res.totalAmount,
                    totalPrice: Number(res.totalPrice).toLocaleString('th', {minimumFractionDigits: 2}),
                    promotionText: res.PromotionText
                })
                resolve();
            })
        })
    }

    const checkUserInit = () => {
        return new Promise(async resolve => {
            let line_profile = !!localStorage.getItem('line_profile') ? DecryptedOBJ(localStorage.getItem('line_profile')) : null;
            if(line_profile !== null)
            {
                NhealthAction.GetMember(line_profile.user_id)
                .then(res => {
                    // console.log('Get Member: ', res);
                    if(res.isSuccess === true)
                    {
                        resolve(res.member.membercode);
                    }else
                    {
                        if(res.errMessage === 'not found !.')
                        {
                            // go to register member
                            // goToRegisCard();
                            resolve(line_profile.user_id);
                        }else
                        {
                            resolve(line_profile.user_id);
                        }
                    }
                })
            }else
            {
                await useLineLogin(lineConfig.nh_services);
            }
        })
    }

    const goToRegisCard = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/welcome-card-register`;
    }

    // On Selected Package
    const onSelectedPackage = (pack) => {
        let refRedirect = DecryptedText(localStorage.getItem('refredirect'));
        window.location.href = `${Base_API.pathWeb}/n-health/nh-services-detail/${pack.id}/${refRedirect}`; 
        // NhealthAction.GetProductOnlineByID(pack.id)
        // .then(res => {
        //     console.log(res);
        //     setOpenDetail(true)
        //     setPackSelected(p1)
        
        //     document.querySelector('body').style.overflow = 'hidden'
        // })
    }

    // Check Status Campaign
    // const checkStatusCampaign = () => {
    //     NhealthAction.CheckCampaign().then(data => {
    //         console.log('Check Campaign: ', data);
    //         if(data.isEnd === false)
    //         {
    //             window.location.href = `${Base_API.pathWeb}/n-health/endcampaign`
    //         }
    //     }) 
    // }
    // Campaign Init
    const campaignInit = () => {
        return new Promise(async resolve => {
            NhealthAction.GetCampaignProductsOnline().then(data => {
                setCampaignData(data);
                // console.log('Get Campaign Product Online: ', data);
                // set date end
                let p1 = String(data.appendDate).split('('); 
                p1 = String(p1[1]).split(')');
                p1 = Number(p1[0]);
                resolve(data.campaign);
            })
        })
    }

    // End Campaign
    const endCampaign = () => {
        window.location.href = `${Base_API.pathWeb}/n-health/endcampaign`;
    }

    // Package Init
    const packagesInit = () => {
        return new Promise(async resolve => {
            localStorage.removeItem('couponselected');
            localStorage.setItem('mainpage', EncryptedText('services')); // set เพื่อเช็คในหน้าทำรายการสำเร็จว่าควรกลับมาที่หน้าไหน packages หรืิิอ nh services 
            NhealthAction.GetProductOnline()
            .then(data => {
                // console.log('Get Products Online: ', data);
                setPackages(data);
                resolve();
            })
        })
    }

    const userInitLine = () => {
        // nh-services UAT (1657272738-7Nak2qpy)
        liff.init({ liffId: lineConfig.nh_services }, () => {
            if (liff.isLoggedIn()) {
              runApp();
            } else {
              liff.login();
            }
        }, err => console.error(err));
    }
    const runApp = () => {
        const idToken = liff.getIDToken();
        let lineProfile;
        const accessToken = liff.getAccessToken();

        liff.getProfile().then(profile => {
            lineProfile = {
                id_token: idToken,
                display_name: profile.displayName,
                picture_url: profile.pictureUrl,
                status_message: profile.statusMessage,
                user_id: profile.userId,
                access_token: accessToken
            }

            window.localStorage.setItem('line_profile', EncryptedOBJ(lineProfile));
        })
    }

    if(loading)
    {
        return (
            <div className="sls-loader-container">
                <div className="sls-loader"></div>
            </div>
        )
    }else
    {
        return (
            <div className="nhsvs-container">
                {/* headtext */}
                <h1 className="header-text">
                    สั่งซื้อสินค้าออนไลน์ 
                </h1>
    
                {/* Card */}
                <div className="card">
                    {packages !== null && packages.map((pack, i) =>  
                        <div 
                            className="item" 
                            key={i}
                            onClick={() => onSelectedPackage(pack)}
                        >
                            {/* sv img */}
                            <img 
                                src={pack.cover}
                                className="sv-img"
                            ></img>
                            <div className="sv-dt">
                                {/* sv name */}
                                <h4 className="sv-name">{pack.pack_type_th}</h4>
                                {/* sv price */}
                                <div className="sv-price">
                                    {pack.price !== pack.flashdeal_price &&
                                        <p className="p">
                                            ฿ {Number(pack.price).toLocaleString('th')}
                                        </p>
                                    }
                                    <p className="flsh-p">
                                        ฿ {Number(pack.flashdeal_price).toLocaleString('th')}
                                    </p>
                                </div>
                            </div>
                        </div> 
                    )}
                </div>
    
                {/* Package Detail */}
                <PackageDetail 
                    openDetail={openDetail} 
                    setOpenDetail={setOpenDetail} 
                    packSelected={packSelected}
                    setPackOrder={setPackOrder}
                    packOrder={packOrder}
                    quantitySelected={quantitySelected}
                    setQuantitySelected={setQuantitySelected}
                />
    
                {/* space */}
                <div className="appm-pck-space"></div>
    
                {/* Choose Order */}
                <Choose_Order 
                    pageDetail={pageDetail}
                    refCampaign={DecryptedText(localStorage.getItem('refredirect'))}
                    type={'services'}
                />
    
                {/* overlay */}
                <Overlay 
                    openDetail={openDetail} 
                    setOpenDetail={setOpenDetail}
                />
            </div>
        )
    }
}

export default ProductsOnline